import { render, staticRenderFns } from "./book-details-popup.vue?vue&type=template&id=df70f27e&scoped=true"
import script from "./book-details-popup.vue?vue&type=script&lang=js"
export * from "./book-details-popup.vue?vue&type=script&lang=js"
import style0 from "./book-details-popup.vue?vue&type=style&index=0&id=df70f27e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df70f27e",
  null
  
)

export default component.exports